export default __webpack_public_path__ + "static/media/AxionSupernovaBG1.08ec4799.jpg";